export enum SubtoolVertex {
  None = 'none',
  AddVertex = 'add-vertex',
  RemoveVertex = 'remove-vertex',
  MoveVertex = 'move-vertex',
  ConnectVertex = 'connect-vertex',
}
